// Mock data para ChatAlfa

export const useCases = [
  { id: 'real-estate', label: 'Imobiliária' },
  { id: 'aesthetic-clinic', label: 'Clínica estética' },
  { id: 'medical-center', label: 'Centro médico' },
  { id: 'beauty-salon', label: 'Salão de beleza' },
  { id: 'dental-clinic', label: 'Clínica odontológica' },
  { id: 'legal-services', label: 'Serviços jurídicos' },
  { id: 'spa-massage', label: 'Spa & massagem' },
  { id: 'restaurants', label: 'Restaurantes & cafés' },
  { id: 'insurance', label: 'Seguros' },
];

export const useCasePrompts = {
  'real-estate': 'Agente IA que qualifica leads de imóveis, agenda visitas e fornece detalhes instantâneos para potenciais compradores',
  'aesthetic-clinic': 'Agente IA que pergunta qual tratamento o cliente deseja e sua data e hora preferidas, então encaminha o agendamento para aprovação da equipe',
  'medical-center': 'Agente IA que gerencia agendamento de consultas, responde dúvidas comuns de saúde e encaminha casos urgentes para a equipe médica',
  'beauty-salon': 'Agente IA que agenda tratamentos de beleza, recomenda serviços baseado nas preferências do cliente e envia lembretes de agendamento',
  'dental-clinic': 'Agente IA que agenda consultas odontológicas, responde FAQ sobre procedimentos e envia instruções de cuidados pós-atendimento',
  'legal-services': 'Agente IA que qualifica consultas jurídicas, agenda consultas e coleta informações iniciais do caso',
  'spa-massage': 'Agente IA que agenda sessões de spa, recomenda tratamentos e gerencia recompensas de fidelidade para clientes recorrentes',
  'restaurants': 'Agente IA que gerencia reservas de mesa, responde perguntas sobre cardápio e administra reservas para eventos especiais',
  'insurance': 'Agente IA que qualifica leads de seguros, agenda consultas e fornece informações instantâneas sobre apólices',
};

export const heroStats = [
  {
    percentage: '25%',
    description: 'mais agendamentos confirmados via WhatsApp & Instagram',
  },
  {
    percentage: '30%',
    description: 'mais visitas recorrentes com lembretes de fidelidade',
  },
  {
    percentage: '25%',
    description: 'mais clientes aceitam serviços extras com ofertas automáticas',
  },
];

export const aiTools = [
  {
    id: 'automated-ads',
    title: 'Anúncios automatizados',
    subtitle: 'Mais clientes com menos esforço',
    description: 'Capture leads de anúncios do Facebook & Instagram e responda instantaneamente via WhatsApp ou DM.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
  },
  {
    id: 'instant-answers',
    title: 'Respostas instantâneas',
    subtitle: 'Converta 24/7, mesmo enquanto dorme',
    description: 'Respostas com IA atendem consultas de clientes o dia todo, nunca perdendo um lead.',
    image: 'https://images.unsplash.com/photo-1556745753-b2904692b3cd?w=600&q=80',
  },
  {
    id: 'team-messaging',
    title: 'Mensagens em equipe',
    subtitle: 'Mantenha sua equipe de vendas sincronizada',
    description: 'Colabore com sua equipe em tempo real com caixa de entrada compartilhada e atribuição de conversas.',
    image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&q=80',
  },
  {
    id: 'broadcasts',
    title: 'Broadcasts & notificações',
    subtitle: 'Mantenha-se presente na mente dos clientes',
    description: 'Envie mensagens promocionais segmentadas e lembretes para reengajar clientes antigos.',
    image: 'https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=600&q=80',
  },
];

export const topFeatures = [
  {
    id: 'easy-setup',
    title: 'Configuração fácil',
    description: 'Coloque a IA para funcionar em poucos cliques',
    icon: 'settings',
  },
  {
    id: 'take-control',
    title: 'Controle a qualquer momento',
    description: 'Mude de IA para humano quando precisar',
    icon: 'user-check',
  },
  {
    id: '24-7-support',
    title: 'Suporte 24/7',
    description: 'Falamos sua língua e estamos prontos para ajudar',
    icon: 'headphones',
  },
  {
    id: 'smart-context',
    title: 'Contexto inteligente',
    description: 'Entende o histórico do seu cliente',
    icon: 'brain',
  },
];

export const integrations = [
  { name: 'Stripe', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/stripe/stripe-original.svg' },
  { name: 'Calendly', logo: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=80&q=80' },
  { name: 'Zapier', logo: 'https://cdn.worldvectorlogo.com/logos/zapier-1.svg' },
  { name: 'Shopify', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/shopify/shopify-original.svg' },
  { name: 'Google', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg' },
];

export const testimonials = [
  {
    id: 1,
    name: 'Alejandro',
    location: 'São Paulo',
    text: 'Centraliza conversas com clientes, mantém histórico completo de interações e ajuda a equipe de suporte a gerenciar consultas de forma eficiente.',
    avatar: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=100&q=80',
  },
  {
    id: 2,
    name: 'Maria',
    location: 'Rio de Janeiro',
    text: 'Às vezes clientes enviam áudios longos descrevendo sua situação, e o bot consegue processar capturando as informações necessárias.',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&q=80',
  },
  {
    id: 3,
    name: 'João',
    location: 'Belo Horizonte',
    text: 'A capacidade do bot de coletar informações antecipadamente e filtrar leads reduziu a necessidade de follow-ups manuais — economizando tempo que seria gasto contatando vários prospects.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80',
  },
];

export const faqData = [
  {
    question: 'O que é o ChatAlfa?',
    answer: 'ChatAlfa é uma ferramenta simples e leve construída para empresas focadas em WhatsApp/Instagram. Ela combina mensagens com clientes, agendamentos, follow-ups e automação em um só lugar — sem a complexidade de CRMs completos.',
  },
  {
    question: 'Como o ChatAlfa me ajuda a fechar mais clientes no piloto automático?',
    answer: 'ChatAlfa automatiza WhatsApp, Facebook, Instagram, TikTok DMs, gerencia agendamentos e envia follow-ups inteligentes para você converter leads em clientes pagantes — mesmo enquanto está ocupado com seu trabalho.',
  },
  {
    question: 'Preciso de conhecimento técnico ou programação para configurar?',
    answer: 'Não. ChatAlfa foi projetado para empresários sem tempo — a configuração leva minutos, sem necessidade de código ou integrações complexas.',
  },
  {
    question: 'Posso gerenciar agendamentos e chats em um só lugar?',
    answer: 'Sim. ChatAlfa mantém todas as suas conversas do WhatsApp & Instagram, solicitações de agendamento e detalhes dos clientes em uma única ferramenta, para você nunca perder um lead ou esquecer de fazer follow-up.',
  },
  {
    question: 'Por que escolher ChatAlfa em vez de CRMs genéricos ou bots de DM?',
    answer: 'Diferente de CRMs pesados ou bots simples de DM, ChatAlfa foi construído para PMEs focadas em mensagens. É acessível, fácil de usar e combina automação de WhatsApp/Social DM com agendamentos e follow-ups — tudo que empresas de beleza e estética precisam, nada que não precisam.',
  },
  {
    question: 'Como posso automatizar meu marketing com ChatAlfa?',
    answer: 'Com a ferramenta leve do ChatAlfa, você pode automatizar marketing no WhatsApp, Facebook, TikTok e Instagram sem dores de cabeça técnicas. Capture e qualifique leads de DMs ou Click-to-ads, agende compromissos instantaneamente, envie follow-ups personalizados e nutra clientes — tudo em uma ferramenta simples.',
  },
  {
    question: 'Meus dados de clientes estão seguros com ChatAlfa?',
    answer: 'Sim. ChatAlfa é totalmente seguro e compatível com LGPD/GDPR. Todos os dados dos seus clientes — incluindo mensagens — são criptografados e armazenados com segurança. Nunca vendemos ou compartilhamos suas informações, então você mantém o controle enquanto protege a privacidade dos seus clientes.',
  },
];

export const navLinks = [
  { label: 'Canais', hasDropdown: true },
  { label: 'Preços', hasDropdown: false, href: '#pricing' },
  { label: 'Casos de uso', hasDropdown: true },
  { label: 'Soluções', hasDropdown: true },
  { label: 'Programa de Afiliados', hasDropdown: false, href: '#affiliate' },
];

export const footerLinks = {
  product: [
    { label: 'Funcionalidades', href: '#' },
    { label: 'Preços', href: '#' },
    { label: 'Integrações', href: '#' },
    { label: 'API', href: '#' },
  ],
  company: [
    { label: 'Sobre', href: '#' },
    { label: 'Blog', href: '#' },
    { label: 'Carreiras', href: '#' },
    { label: 'Contato', href: '#' },
  ],
  resources: [
    { label: 'Documentação', href: '#' },
    { label: 'Central de Ajuda', href: '#' },
    { label: 'Comunidade', href: '#' },
    { label: 'Parceiros', href: '#' },
  ],
  legal: [
    { label: 'Política de Privacidade', href: '#' },
    { label: 'Termos de Serviço', href: '#' },
    { label: 'Política de Cookies', href: '#' },
    { label: 'LGPD', href: '#' },
  ],
};
